
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","viewBox":"0 0 52 52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.9851 0C11.6335 0 0 11.6402 0 26C0 40.3598 11.6335 52 25.9851 52C39.1855 52 50.2655 42.0992 51.809 29.0888C51.9753 27.6614 50.9593 26.3328 49.5327 26.1612C48.1087 25.9948 46.7783 27.0114 46.612 28.4388C45.3777 38.8388 36.5454 46.8 25.9851 46.8C14.5049 46.8 5.19701 37.4868 5.19701 26C5.19701 14.5132 14.5049 5.2 25.9851 5.2C28.3835 5.2 30.7585 5.63418 32.9699 6.41938C34.3211 6.89778 35.7373 6.14638 36.218 4.79438C36.6961 3.43978 36.0257 1.94223 34.6745 1.46123C31.9096 0.48103 28.9759 0 25.9851 0ZM49.3716 5.2C48.7064 5.2 48.01 5.43402 47.5033 5.93061L24.8469 28.275C24.1791 28.9328 23.5061 28.8054 22.9812 28.0306L20.3827 24.2112C19.5875 23.0386 17.9193 22.698 16.7292 23.4806C15.5365 24.2632 15.2013 25.883 15.9964 27.0556L18.5949 30.875C20.9362 34.3304 25.5173 34.788 28.503 31.85L51.2399 9.58877C52.2534 8.59037 52.2534 6.92902 51.2399 5.93061C50.7332 5.43142 50.0368 5.2 49.3716 5.2Z","fill":"url(#paint0_linear_763_24017)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_763_24017","x1":"0","y1":"26","x2":"52","y2":"26","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#18E4F2"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#857FCF"}})])])])
          )
        }
      }
    